import { projectsAPI } from 'api';
import { call, put } from 'redux-saga/effects';
import {
  getProjectPaymentSettingSuccess,
  getProjectPaymentSettingFailed,
} from '../actions';

export default function* handleGetPaymentSetting({ payload }) {
  try {
    const data = yield call(projectsAPI.paymentSetting, payload.id);

    yield put(getProjectPaymentSettingSuccess(payload.id, data));
  } catch (e) {
    yield put(getProjectPaymentSettingFailed(e));
  }
}
